import { useEffect } from "react";

/**
 * Component for adding JSON-LD structured data to the page
 * @param {Object} props - Component props
 * @param {Object} props.data - Structured data object
 * @param {string} [props.id] - Optional ID for the script tag
 */
const StructuredData = ({ data, id = "structured-data" }) => {
  useEffect(() => {
    if (!data) return;

    // Create script element
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);

    // Add to head
    document.head.appendChild(script);

    // Cleanup
    return () => {
      const existingScript = document.getElementById(id);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [data, id]);

  return null;
};

export default StructuredData;
